import React from 'react';

import {utils} from '../utils';
import {theme} from '../constants';

interface ButtonProps {
  title: string;
  onClick?: () => void;
  disabled?: boolean;
  colorScheme?: 'dark' | 'light' | 'danger';
  style?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
}

export const Button: React.FC<ButtonProps> = ({
  title,
  style,
  onClick,
  disabled,
  colorScheme = 'dark',
  containerStyle,
}) => {
  const base: React.CSSProperties = {
    width: '100%',
    minHeight: 48,
    textAlign: 'center',
    fontSize: 15,
    letterSpacing: '-0.01em',
    borderRadius: 10,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.45 : 1,
    fontFamily: "'SS3', sans-serif",
    fontWeight: 600,
    border: 'none',
    ...utils.flexCenter(),
  };

  const schemeStyles: React.CSSProperties =
    colorScheme === 'dark'
      ? {
          backgroundColor: theme.colors.mainDark,
          color: theme.colors.white,
        }
      : colorScheme === 'danger'
      ? {
          backgroundColor: theme.colors.dangerRed,
          color: theme.colors.white,
        }
      : {
          backgroundColor: theme.colors.ghostWhite,
          color: theme.colors.mainDark,
          border: `1px solid ${theme.colors.aliceBlue2}`,
        };

  return (
    <div style={{...containerStyle}}>
      <button
        type='button'
        onClick={onClick}
        disabled={disabled}
        style={{...base, ...schemeStyles, ...style}}
      >
        {title}
      </button>
    </div>
  );
};
